const ENVIRONMENT_ENDPOINTS = {
  production: 'https://www.trainwithkickoff.com',
  beta: 'https://beta.trainwithkickoff.com',
  staging: 'https://staging.trainwithkickoff.com',
  growth: 'https://growth.trainwithkickoff.com',
  development: 'http://localhost:3000',
}

export const getRelatedCategories = (categorySlug, categories) => {
  const isRelated = category => {
    if (category.fields.slug === categorySlug) return true
    if (category.fields.parent) return isRelated(category.fields.parent)
  }

  const addParents = (acc, parent) => {
    if (parent.fields.parent) addParents(acc, parent.fields.parent)
    return acc.push(parent)
  }

  return categories.reduce((acc, c) => {
    if (c.fields.slug === categorySlug) {
      acc.push(c)
    }

    if (c.fields.slug === categorySlug && c.fields.parent) {
      addParents(acc, c.fields.parent)
    }

    if (c.fields.parent && isRelated(c.fields.parent)) {
      acc.push(c)
    }
    return acc
  }, [])
}

export const getMainCategories = categories => {
  return categories.filter(
    ({ fields }) => !isWorkoutCategory(fields) && !fields.parent
  )
}

export const isWorkoutCategory = category => {
  return (
    category.name?.toLowerCase() === 'workout' &&
    category.parent.fields.name.toLowerCase() === 'fitness'
  )
}

export const isMainCategory = category => !category.parent

// TODO need to fix
export const constructCategorySlug = (category, slug = '') => {
  if (category?.parent) {
    return constructCategorySlug(
      category.parent.fields,
      `${category.slug}${slug === '' ? '' : `/${slug}`}`
    )
  }
  return `/blog/${category?.slug}${slug === '' ? '' : `/${slug}`}`
}

export const createSlug = (category, post = undefined) => {
  return constructCategorySlug(category, `${post ? `/${post.slug}` : ''}`)
}

export const createMetaTags = (post, postSlug = '') => {
  if (!post || !post.fields) return {}

  let slug = Array.isArray(postSlug)
    ? `blog/${postSlug.join('/')}`
    : postSlug
    ? `blog/${postSlug}`
    : 'blog'

  const ogImage = post.fields.ogImage
    ? post.fields.ogImage.fields.file.url
    : post.fields.featureImage
    ? post.fields.featureImage.fields.file.url
    : ''

  const twitterImage = post.fields.twitterImage
    ? post.fields.twitterImage.fields.file.url
    : post.fields.featureImage
    ? post.fields.featureImage.fields.file.url
    : ''

  const categories =
    post.fields.categories && post.fields.categories.length
      ? getMainCategories(post.fields.categories)
      : []

  let ogTag = ''
  if (categories.length) {
    ogTag = categories[0].fields.name
  }

  const og = {
    title:
      post.fields.ogTitle || post.fields.metaTitle || post.fields.title || '',
    description: post.fields.ogDescription || post.fields.metaDescription || '',
    url: `${ENVIRONMENT_ENDPOINTS[process.env.NODE_ENV]}/${slug}`,
    image: ogImage && `https:${ogImage}`,
    tag: ogTag,
    type: post.fields.type || 'article',
    updatedAt: post.sys?.updatedAt || '',
    facebookUrl: post.fields.author?.facebookUrl || '',
  }

  const twitter = {
    title:
      post.fields.twitterTitle ||
      post.fields.metaTitle ||
      post.fields.title ||
      '',
    description:
      post.fields.twitterDescription || post.fields.metaDescription || '',
    url: `${ENVIRONMENT_ENDPOINTS[process.env.NODE_ENV]}/${slug}`,
    image: twitterImage && `https:${twitterImage}`,
    creator:
      post.fields.author && post.fields.author.fields.twitterUrl
        ? post.fields.author.fields.twitterUrl.replace(
            'https://twitter.com/',
            '@'
          )
        : '',
  }

  return {
    canonical: `${ENVIRONMENT_ENDPOINTS[process.env.NODE_ENV]}/${slug}`,
    title: post.fields.metaTitle || post.fields.title || '',
    description: post.fields.metaDescription || '',
    og,
    twitter,
  }
}
